<div class="component-container flex flex-col justify-center items-center">
  <div class="heading mb-[3rem]">
    Change User Status
  </div>
  <div
    class="details w-full flex flex-col justify-start items-center gap-[2rem]">
    <div
      class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]"
    >
      <div class="label w-full sm:w-1/3">
        User :
      </div>
      <div class="value w-full sm:w-2/3">
        {{ user || 'NA' }}
      </div>
    </div>
    <div
      class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]"
    >
      <div class="label w-full sm:w-1/3">
        Role :
      </div>
      <div class="value w-full sm:w-2/3">
        {{ role || 'NA' }}
      </div>
    </div>
    <div
      class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]"
    >
      <div class="label w-full sm:w-1/3">
        Current Status :
      </div>
      <div class="value w-full sm:w-2/3">
        {{ currentUserStatus || 'NA' }}
      </div>
    </div>
    <div
      class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]"
    >
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        Change Status to :
      </div>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['userStatus']"
        [loading]="userStatusLoading"
        [options]="userStatusDropdownOptions"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="userStatus"
        placeholder="Select one"
        type="small"
      />
    </div>
  </div>
  <div class="action-section flex flex-row
           justify-end items-center w-full">
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="!form.dirty"
      [isLoading]="editUserStatusLoading"
      class="save-btn w-[15rem]"
      type="small"
    >
      Save
    </app-primary-button>
  </div>
</div>
